// extracted by mini-css-extract-plugin
module.exports = {"container":"search_decision_watcher-module__container--3ogqQ"};